import { render, staticRenderFns } from "./NavbarDialog.vue?vue&type=template&id=58f89c79&scoped=true"
import script from "./NavbarDialog.vue?vue&type=script&lang=js"
export * from "./NavbarDialog.vue?vue&type=script&lang=js"
import style0 from "./NavbarDialog.vue?vue&type=style&index=0&id=58f89c79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f89c79",
  null
  
)

export default component.exports